import React, { useRef } from 'react';
import classNames from 'classnames';
import { Translate } from '../../config/TranslationProvider';
import EventsCard from '../card/EventsCard';
import useIntersectionObserver from '../../util/useIntersectionObserver';

const FetchMoreButton = ({fetchMore, canFetchMore, isFetchingMore}) => {
    const fetchMoreButtonRef = useRef();

    useIntersectionObserver({
        target: fetchMoreButtonRef,
        onIntersect: fetchMore,
        enabled: canFetchMore,
    });

    if (canFetchMore) {
        return (
            <button
                ref={fetchMoreButtonRef}
                onClick={() => fetchMore()}
                disabled={isFetchingMore}
                className="btn btn-block btn-secondary"
            >
                <Translate value={isFetchingMore ? 'loading_events' : 'show_more_events'} />
            </button>
        );
    }

    return null;
};

const EventsListing = ({type = 'grid12', eventGroups, fetchMore, canFetchMore, isFetchingMore, categories}) => {
    let gridClass = classNames({
        'col-lg-4 col-sm-6': type === 'grid4',
        'col-lg-6 col-sm-6': type === 'grid6',
        'col-lg-12': type === 'grid12',
    });

    let listClass = classNames({
        'atbd_listing_list': type === 'grid12'
    });

    return (
        <>
            <div className="row">
                {eventGroups.map(events => events.data.filter(
                    // Skip events without dates. This can happen if the event was rescheduled and the built filter
                    // query somehow does match the event but the actual event dates don't.
                    event => event.event_dates && event.event_dates.length > 0
                ).map((value, key) => (
                    <div className={gridClass} key={key}>
                        <div className={listClass}>
                            <EventsCard event={value} isGrid={type !== 'grid12'} allCategories={categories} />
                        </div>
                    </div>
                )))}
            </div>

            {/* Enable fetch more button if available */}
            {fetchMore && (
                <FetchMoreButton fetchMore={fetchMore} canFetchMore={canFetchMore} isFetchingMore={isFetchingMore} />
            )}
        </>
    );
};

export default EventsListing;
